import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { BannerService } from '../../../services/mensagem.service';

@Component({
  selector: 'app-lancamento-mensagem',
  templateUrl: './lancamento-mensagem.component.html',
  styleUrls: ['./lancamento-mensagem.component.css'],
  standalone: false
})
export class LancamentoMensagemComponent implements OnInit {
  bannerForm!: UntypedFormGroup;
  idmensagem = null;
  dataBannerAtt = null;
  bannerPreview: string | ArrayBuffer | null = null;

  exibicoes = [
    { label: 'Home', value: 'HOME' },
    { label: 'Página de Pesquisa', value: 'PESQUISA' }
  ];
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private bannerService: BannerService,
  ) {
    this.bannerForm = this.newFormBanner();

    this.route.params.subscribe(res => this.idmensagem = res.idmensagem);
  }

  ngOnInit(): void {
    if (this.idmensagem !== undefined) {
      this.bannerService.detalhar(this.idmensagem).subscribe((p: any) => {
        let item = p.data;
        this.dataBannerAtt = item;
        this.bannerPreview = item?.path ?? null;
        this.bannerForm.get('idmensagem').setValue(item.idmensagem);
        this.bannerForm.get('link').setValue(item.link);
        this.bannerForm.get('exibicao').setValue(item.exibicao ?? []);
      });
    } else {
      this.bannerForm.reset();
    }
  }

  newFormBanner() {
    return new UntypedFormGroup({
      idmensagem: new UntypedFormControl(''),
      base64: new UntypedFormControl(''),
      link: new UntypedFormControl(''),
      exibicao: new UntypedFormControl([], [Validators.required])
    });
  }

  onSubmitMensagem() {
    if (this.bannerForm.valid) {
      const formValue = this.bannerForm.value;
      if (this.idmensagem === undefined && !formValue.base64) {
        this.message.error('Selecione uma imagem para o banner.');
        return;
      }
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idmensagem !== undefined) {
        let dadosEdicao = this.bannerForm.value;

        this.bannerService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/mensagem']);
          this.message.remove(id);
          this.message.success('O banner foi atualizado com SUCESSO!');
        });

      } else {
        this.bannerService.criar(this.bannerForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/mensagem']);
          this.message.success('O banner foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.bannerForm.controls) {
        this.bannerForm.controls[i].markAsDirty();
        this.bannerForm.controls[i].updateValueAndValidity();
      }
    }
  }

  onBannerFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input?.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.bannerPreview = reader.result;
      this.bannerForm.get('base64')?.setValue(reader.result);
    };
    reader.readAsDataURL(file);
  }
}
